// DPR auto-scale — warm-up frame budget check. Most desktops hit 16ms easily;
// some mobile / Linux boxes with mid-tier integrated GPUs choke when DPR=2 +
// feedback texture is full-resolution. We measure the average frame time over
// the first ~120 frames after parameters arrive, and if it exceeds the budget,
// step the renderer's DPR down once (never up).
//
// One-shot, idempotent. Doesn't keep watching forever — the goal is to size
// the texture, not to chase momentary GC pauses.

const WARMUP_FRAMES = 120;
const BUDGET_MS = 18; // ~55 fps; below 60 but above the "noticeably stuttery" line

export interface AutoScaleHandle {
  noteFrame(deltaMs: number): void;
}

export function makeAutoScale(setDprMultiplier: (mult: number) => void): AutoScaleHandle {
  let n = 0;
  let sum = 0;
  let done = false;

  return {
    noteFrame(deltaMs: number): void {
      if (done) return;
      // Discard the first 10 frames to avoid measuring shader compile + texture upload
      if (n < 10) { n++; return; }
      sum += deltaMs;
      n++;
      if (n >= WARMUP_FRAMES + 10) {
        const avg = sum / WARMUP_FRAMES;
        if (avg > BUDGET_MS) {
          const ratio = Math.max(0.5, BUDGET_MS / avg);
          setDprMultiplier(ratio);
          console.info(`[herminator] auto-scale DPR: avg frame ${avg.toFixed(1)}ms over budget ${BUDGET_MS}ms; scaling textures by ${ratio.toFixed(2)}`);
        }
        done = true;
      }
    },
  };
}
